import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TopDestinationList from 'components/Common/TopDestinationsList/TopDestinationList'
import Divider from 'components/Luxkit/Divider'
import TrustIndicatorSection from 'home/components/TrustIndicatorSection/TrustIndicatorSection'
import React from 'react'
import { Route } from 'react-router'
import BottomSection from '../BottomSection'
import LayoutContainer from 'components/Common/LayoutContainer'
import { rem } from 'polished'
import styled from 'styled-components'
import TopSection from '../TopSection'
import { isLoggedIn } from 'selectors/accountSelectors'
import { connect } from 'react-redux'
import AgentHubGuestFooter from './AgentHubGuestFooter'

const StyledLayoutContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
`

const TopSectionWrapper = styled(TopSection)`
  padding-bottom: ${rem(44)};
  padding-top: ${rem(44)};
`

interface Props {
  footerInView: boolean
}

interface MappedStateProps {
  isLoggedIn: boolean
}

function AgentHubFooter(props: Props & MappedStateProps) {
  const { footerInView, isLoggedIn } = props

  if (!isLoggedIn) {
    return (
      <AgentHubGuestFooter />
    )
  }

  return (
    <>
      <Pane>
        <Route exact path="/:regionCode/hotels" component={TopDestinationList} />
        <Route exact path="/:regionCode/home-preview" component={TopDestinationList} />
        <Route exact path="/:regionCode" component={TopDestinationList} />
        {footerInView && <StyledLayoutContainer>
          <VerticalSpacer gap={40}>
            <Divider kind="primary" />
            <TrustIndicatorSection />
            <Divider kind="primary" />
          </VerticalSpacer>
          <TopSectionWrapper />
        </StyledLayoutContainer>
        }
      </Pane>
      {footerInView && <BottomSection />}
    </>
  )
}

export default connect<MappedStateProps, undefined, {}, App.State>((state) => {
  return {
    isLoggedIn: isLoggedIn(state),
  }
})(AgentHubFooter)
